<template>
    <div class="mped-filter d-flex">
        <dx-select-box
            v-model="state.monthId"
            :data-source="monthDataSource"
            width="100%"
            value-expr="id"
            display-expr="name"
            :showClearButton="false"
            @valueChanged='valueChanged()'
        />
    </div>
    <div class="mped-filter d-flex">
        <dx-select-box
            v-model="state.year"
            :data-source="yearDataSource"
            width="100%"
            :showClearButton="false"
            @valueChanged='valueChanged()'
        />
    </div>
    <div class="mped-filter mped-filter-department d-flex">
        <dx-select-box
            v-model="state.departmentId"
            :data-source="depsDataSource"
            placeholder="Подразделение"
            width="100%"
            value-expr="id"
            display-expr="name"
            :searchEnabled="true"
            :showClearButton="false"
            :resize-enabled="true"
            item-template="selectBoxItemTemplate"
            @valueChanged='valueChanged()'
        >
            <template #selectBoxItemTemplate="{ data }">
                <div class="select-box-item" :data-level="data.level">
                    <span v-for="i in data.level" :key="i">&nbsp;&nbsp;</span>
                    {{ data.name }}
                </div>
            </template>
        </dx-select-box>

    </div>
    <div class="mped-filter d-flex">
        <dx-radio-group
            class="col-form-label"
            v-model="state.viewMode"
            :dataSource="viewModeDataSource"
            value-expr="id"
            display-expr="name"
            @value-changed="valueChanged()"
            layout="horizontal"/>
        <dx-check-box
            class="mped-filter-check-box"
            text="НД по видам"
            v-model="state.notMainTypes"
            :disabled="disabledType"
        />
    </div>
</template>

<script>
export default  {
    name: 'mped-filter-dep-date-component'
}
</script>

<script setup>
import { computed, onBeforeMount, ref, watch, defineProps, onMounted } from 'vue';
import { DxSelectBox, DxCheckBox } from 'devextreme-vue';
import DxRadioGroup from 'devextreme-vue/radio-group';

import { getDepartments } from '@/views/mped/services/mped-department-service';
import { getYearsList, monthsList, viewModeList } from '@/views/mped/services/mped-estimate-service';
import { setUserData, getUserData } from '@/views/mped/services/mped-service';

const state = ref({
    monthId: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
    departmentId: null,
    viewMode: '0',
    notMainTypes: false
});
const depsDataSource = ref();
const monthDataSource = ref();
const yearDataSource = ref();
const viewModeDataSource = ref();

const props = defineProps({
    userDataKey: {
        type: String
    }
});
const emit = defineEmits(['valueChanged', 'viewChanged']);

const disabledType = computed({
    get: () => state.value.viewMode !== '1'
});

watch(() => state.value.viewMode, (newValue, oldValue) => {
    if (oldValue === '1' && newValue !== '1' && state.value.notMainTypes)
        state.value.notMainTypes = false;
    else
        viewChanged();
});

watch( () => state.value.notMainTypes, () => {
    viewChanged();
});

watch(state.value, () => {
    saveUserData();
});

onBeforeMount(async () => {
    viewModeDataSource.value = viewModeList;
    monthDataSource.value = monthsList;
    yearDataSource.value = getYearsList((new Date()).getFullYear(), 4, 4);
    depsDataSource.value = await getDepartments();
});

onMounted(() => {
    if (props.userDataKey && getUserData(props.userDataKey)) {
        state.value = getUserData(props.userDataKey);
    }
})

const valueChanged = () => {
    emit('valueChanged', state.value);
};

const viewChanged = () => {
    emit('viewChanged', state.value);
};

const saveUserData = () => {
    if (props.userDataKey) {
        setUserData(props.userDataKey, state.value);
    }
}

</script>

<style lang="scss" scoped>

.select-box-item[data-level="1"] {
    align-items: center;
    font-weight: bold;
    text-align: center
}

.mped-filter-check-box {
    padding: 5px 5px 5px 10px;
}

.mped-filter {
    padding-left: 10px;
    padding-right: 10px;
}

</style>
